<div class="panel">
  <div class="panel-title" *ngIf="agent$ | async as agent">
    <h3 class="title ellipsis" title="{{ agent }}">{{ agent }}</h3>
  </div>
  <div
    class="panel-body"
    *ngIf="{
      teams: teams$ | async,
      groups: groups$ | async,
      supervisors: supervisors$ | async
    } as data"
  >
    <h4>{{ 'commons:basic.team' | translate }}</h4>
    <cng-truncate-list [value]="data.teams" [max]="Infinity"></cng-truncate-list>
    <span *ngIf="data.teams && data.teams.length <= 0">{{ 'agent:contact.info.there_is_no_team' | translate }}</span>
    <hr aria-hidden="true" />

    <h4>{{ 'commons:basic.groups' | translate }}</h4>
    <cng-truncate-list [value]="data.groups" [max]="Infinity"></cng-truncate-list>
    <span *ngIf="data.groups && data.groups.length <= 0">{{ 'agent:contact.info.there_is_no_group' | translate }}</span>
    <hr aria-hidden="true" />

    <h4>{{ 'commons:basic.supervisors' | translate }}</h4>
    <cng-truncate-list [value]="data.supervisors" [max]="Infinity"></cng-truncate-list>
    <span *ngIf="data.supervisors && data.supervisors.length <= 0">{{ 'agent:contact.info.there_is_no_supervisor' | translate }}</span>
  </div>
</div>
